document.addEventListener("DOMContentLoaded", () => {

  const saveGiftInformation = () => {
    const checkbox = document.getElementById("GiftOrder");
    const message = document.getElementById("GiftMessage");

    if (!checkbox || !message) return;

    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        attributes: {
          "Gift Order": checkbox.checked ? "Yes" : "No",
          "Gift Message": message.value
        }
      })
    });
  };

  const updateGiftMessageVisibility = () => {
    const checkbox = document.getElementById("GiftOrder");
    const container = document.getElementById("GiftMessageContainer");

    if (!checkbox || !container) return;

    container.style.display = checkbox.checked ? "block" : "none";
  };

  document.addEventListener("change", (event) => {

    if (event.target.id === "GiftOrder") {
      updateGiftMessageVisibility();
      saveGiftInformation();
    }

    if (event.target.id === "GiftMessage") {
      saveGiftInformation();
    }

  });

  updateGiftMessageVisibility();

});